import useModalTestPlayer from "hooks/useModalTestPlayer"
import AdamTextInput from "../AdamTextInput/AdamTextInput"

const AdamVideoUrlTextInput = (props) => {

    const {
        openTestPlayer,
    } = useModalTestPlayer()

    props = {
        ...props,
        labelText: (
            <>
                <span>{props.labelText}</span>
                {
                    props.value ? <span> (<a onClick={() => openTestPlayer(props.value)}>Test</a>)</span> : null
                }
            </>
        )
    }
    return <AdamTextInput {...props} />
}

export default AdamVideoUrlTextInput